import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const ExpandAll = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M12 18.17L8.83 15L7.42 16.41L12 21L16.59 16.41L15.17 15M12 5.83L15.17 9L16.58 7.59L12 3L7.41 7.59L8.83 9L12 5.83Z" />
  </SvgIcon>
));

ExpandAll.displayName = 'ExpandAll';

export default ExpandAll;
